const doc = [({"zh_tw":({"adminLabelCompanyInvoice":({"createdDate":"創建日期", "price":"價錢", "uniqueId":"發票號碼。"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;